import type { PipelineCard, PipelineTone } from '@/pages/pipelines/common/types';
import { getInvestmentStageLabel } from '@/pages/pipelines/common/utils/stage-presentation';

const INVESTMENT_STAGE_BADGE_LABELS: Record<string, string> = {
  DueDiligenceViewed: 'DD viewed',
  SubscriptionStarted: 'Sub. started',
  AgreementSigned: 'Agr. signed',
};

const INVESTMENT_STAGE_BADGE_TONES: Record<string, PipelineTone> = {
  LinkClicked: 'blue',
  DueDiligenceViewed: 'purple',
  SubscriptionStarted: 'amber',
  EligibilitySubmitted: 'amber',
  DataSubmissionAcknowledged: 'amber',
  AgreementSigned: 'amber',
  PaymentMethodSelected: 'amber',
  FundsSent: 'teal',
  FundsReceived: 'teal',
  Invested: 'green',
  Redeemed: 'neutral',
  Rejected: 'red',
  NotEligible: 'neutral',
  Expired: 'neutral',
};

export { getInvestmentStageLabel };

export const getInvestmentStageBadge = (stage: string): PipelineCard['badges'][number] => ({
  key: 'stage',
  label: INVESTMENT_STAGE_BADGE_LABELS[stage] ?? getInvestmentStageLabel(stage),
  tone: INVESTMENT_STAGE_BADGE_TONES[stage] ?? 'neutral',
  variant: 'muted',
});
